import {
    PRIVACY_POLICY_LINK,
    SOFTWARE_LICENSE_AGREEMENT_LINK,
    TERMS_OF_SERVICE_LINK,
} from "constant";
import { Col, Container, Row } from "react-bootstrap";

const About = () => {
    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <h5 className="page-title">About</h5>
                    <Col sm="12" className="mt-2">
                        <div className="empty-widget p-2">
                            <Row>
                                <Col sm={12}></Col>
                            </Row>
                            <Col sm="12">
                                <a
                                    className="mt-2 mb-2 btn btn-primary"
                                    href={TERMS_OF_SERVICE_LINK}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Terms of Service
                                </a>
                            </Col>
                            <Col sm="12">
                                <a
                                    className="mt-2 mb-2 btn btn-primary"
                                    href={PRIVACY_POLICY_LINK}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Privacy Policy
                                </a>
                            </Col>
                            <Col sm="12">
                                <a
                                    className="mt-2 mb-2 btn btn-primary"
                                    href={SOFTWARE_LICENSE_AGREEMENT_LINK}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Licenses
                                </a>
                            </Col>
                            <Col sm="12">
                                <h6>Version: 2.3.0_3.1.3</h6>
                            </Col>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default About;
